import React from "react";
import ProductGallery from "web/react/components/product-gallery/product-gallery";
import {
    ProductCardSerializer,
    ProductImageGallerySerializer,
    ProductSerializer,
} from "web/types/serializers";

interface PDPGalleryProps {
    product: ProductSerializer | ProductImageGallerySerializer;
    relatedProducts?: ProductCardSerializer[];
    hasRelatedProductsSidebar: boolean;
    variant?: "oos-carousel";
}

function PDPGallery({
    product,
    relatedProducts,
    hasRelatedProductsSidebar,
    variant,
}: PDPGalleryProps): React.ReactElement {
    return (
        <ProductGallery
            relatedProducts={relatedProducts}
            images={product.images}
            currentLinkId={(product as ProductImageGallerySerializer).buy_option_id}
            hasRelatedProductsSidebar={hasRelatedProductsSidebar}
            variant={variant}
            productId={product.product_id}
            buyOptionId={(product as ProductImageGallerySerializer).buy_option_id}
        />
    );
}

export default PDPGallery;
